import type { User } from "firebase/auth";
import { isProfileComplete } from "./ensureUser";
import type { ProfileLoadError } from "../hooks/useProfile";
import type { UserProfile } from "../types/models";

export type StartupStatus =
  | "loading"
  | "signed_out"
  | "email_verification_required"
  | "onboarding_required"
  | "ready"
  | "recoverable_error"
  | "offline";

export function deriveStartupStatus({
  authLoading,
  user,
  loadingProfile,
  profileError,
  profile,
}: {
  authLoading: boolean;
  user: User | null;
  loadingProfile: boolean;
  profileError: ProfileLoadError | null;
  profile: UserProfile | null;
}): StartupStatus {
  if (authLoading) return "loading";
  if (!user) return "signed_out";
  if (!user.emailVerified) return "email_verification_required";
  if (loadingProfile) return "loading";
  if (profileError) return profileError.offline ? "offline" : "recoverable_error";
  return isProfileComplete(profile) ? "ready" : "onboarding_required";
}
